module.exports = __webpack_public_path__ + "static/media/instructivoaf4.2d896d30.png";